import { Module } from "vuex";
import { RootState } from "@/store/types/root.state";
import { PostState } from "@/store/types/post.state";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import Post from "@/models/post";

export const state: PostState = {
    posts: [],
    post: new Post(),
    postId: '',
    loading: false
};

const namespaced = true;

export const PostModule: Module<PostState, RootState> = {
    namespaced,
    actions,
    getters,
    mutations,
    state,
}